import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/Footer';
import SEO, { breadcrumbSchema } from '../components/SEO';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '28px' }}>
    <h2 style={{ fontSize: '1rem', fontWeight: 700, color: '#111827', marginBottom: '10px', fontFamily: "'Syne', sans-serif" }}>{title}</h2>
    <div style={{ color: '#4b5563', fontSize: '0.85rem', lineHeight: 1.8 }}>{children}</div>
  </div>
);

const TermsConditions = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <div style={{ minHeight: '100vh', background: '#fafafa' }}>
      <SEO
        title="Terms & Conditions"
        description="Terms of use for BookYourSalons. Booking policy, salon partner obligations, payments, cancellations and governing law for our salon booking platform."
        path="/terms"
        schema={breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Terms & Conditions', path: '/terms' },
        ])}
      />
      <div style={{
        background: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(0,0,0,0.06)', padding: '12px 20px',
        display: 'flex', alignItems: 'center', gap: '12px', position: 'sticky', top: 0, zIndex: 100,
      }}>
        <button onClick={() => navigate(-1)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', color: '#374151', fontWeight: 600, fontSize: '0.85rem' }}>
          <ArrowLeft size={18} /> Back
        </button>
        <span style={{ fontWeight: 800, fontFamily: "'Syne', sans-serif", fontSize: '0.9rem', color: '#dc2626' }}>
          Terms & Conditions
        </span>
      </div>

      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '36px 20px' }}>
        <div style={{ background: 'linear-gradient(135deg, #1f2937, #374151)', borderRadius: '16px', padding: '24px', marginBottom: '32px', color: 'white' }}>
          <h1 style={{ fontSize: '1.5rem', fontWeight: 800, fontFamily: "'Syne', sans-serif", marginBottom: '8px' }}>Terms & Conditions</h1>
          <p style={{ opacity: 0.7, fontSize: '0.82rem' }}>Last updated: {new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
          <p style={{ opacity: 0.7, fontSize: '0.82rem', marginTop: '4px' }}>BookYourSalons Private Limited</p>
        </div>

        <div style={{ background: 'white', borderRadius: '16px', padding: '28px', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>

          <Section title="1. Acceptance of Terms">
            <p>By using BookYourSalons ("the Platform"), you agree to these Terms & Conditions. If you do not agree, please do not use the Platform.</p>
          </Section>

          <Section title="2. Use of the Platform">
            <ul style={{ paddingLeft: '18px' }}>
              <li>You must provide accurate information when registering</li>
              <li>You must be 18 years or older to use this Platform</li>
              <li>One account per person is allowed</li>
              <li>You are responsible for maintaining the security of your account</li>
              <li>Misuse, fraud, or abuse of the Platform is strictly prohibited</li>
            </ul>
          </Section>

          <Section title="3. Booking Policy">
            <ul style={{ paddingLeft: '18px' }}>
              <li>Bookings are subject to salon partner approval within 15 minutes</li>
              <li>BookYourSalons is a booking platform and not directly responsible for services rendered by salons</li>
              <li>Cancellation policies are set by individual salon partners</li>
              <li>No-shows may result in account restrictions</li>
            </ul>
          </Section>

          <Section title="4. Salon Partner Obligations">
            <ul style={{ paddingLeft: '18px' }}>
              <li>Salon partners must provide accurate service and pricing information</li>
              <li>Partners must respond to booking requests within 15 minutes</li>
              <li>Partners are responsible for the quality of services provided</li>
              <li>Misleading information may result in account suspension</li>
            </ul>
          </Section>

          <Section title="5. Payments">
            <ul style={{ paddingLeft: '18px' }}>
              <li>Payment at salon: Customers pay directly to the salon</li>
              <li>Online payments: Processed securely via Razorpay</li>
              <li>BookYourSalons is not liable for any payment disputes between customers and salons</li>
            </ul>
          </Section>

          <Section title="6. Intellectual Property">
            <p>All content on the Platform — including logos, text, graphics, and software — is the property of BookYourSalons Private Limited and is protected by Indian copyright law.</p>
          </Section>

          <Section title="7. Limitation of Liability">
            <p>BookYourSalons Private Limited is not liable for:</p>
            <ul style={{ paddingLeft: '18px', marginTop: '8px' }}>
              <li>Quality of services provided by salon partners</li>
              <li>Loss or damage arising from use of the Platform</li>
              <li>Technical issues beyond our reasonable control</li>
            </ul>
          </Section>

          <Section title="8. Governing Law">
            <p>These Terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in India.</p>
          </Section>

          <Section title="9. Contact">
            <p>For questions about these Terms:</p>
            <p style={{ marginTop: '8px' }}>📧 <a href="mailto:bookyoursalons@gmail.com" style={{ color: '#dc2626' }}>bookyoursalons@gmail.com</a></p>
            <p>🏢 BookYourSalons Private Limited, India</p>
          </Section>

          <div style={{ borderTop: '1px solid #f3f4f6', paddingTop: '16px', color: '#9ca3af', fontSize: '0.75rem', textAlign: 'center' }}>
            © {year} BookYourSalons Private Limited. All rights reserved.
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;
